import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f188797"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "ResetPassword Form", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Redefinir a Senha")

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { FormResetPassword } from '@/@types'
import AuthModeLink from './AuthModeLink.vue'
import { AlertNotification } from '@/components'
import useResetPassword from '../composables/useResetPassword'
import { useLoading } from '@/composables'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { notification, isPending, resetPassword } = useResetPassword()
const router = useRouter()
const { overlayLoading } = useLoading()
const formData = ref<FormResetPassword>({
  email: ''
})

watch(
  () => isPending.value,
  () => {
    overlayLoading(isPending.value)
  }
)

const handleSubmit = async () => {
  await resetPassword(formData.value)
  if (!notification.value.error)
    router.push({ name: 'Welcome', params: { mode: 'login' } })
}

return (_ctx: any,_cache: any) => {
  const _component_AppTextfield = _resolveComponent("AppTextfield")!
  const _component_app_btn = _resolveComponent("app-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(handleSubmit, ["prevent"])
    }, [
      _hoisted_2,
      _createVNode(_component_AppTextfield, {
        placeholder: "Email",
        modelValue: formData.value.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_3,
      _createVNode(_component_app_btn, null, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ], 40, _hoisted_1),
    _createElementVNode("div", null, [
      _createVNode(AuthModeLink, {
        text: "Já é cadastrado?",
        textLink: "Acesso o sistema",
        to: { name: 'Welcome', params: { mode: 'login' } }
      }),
      _createVNode(AuthModeLink, {
        text: "Ainda não em cadastro?",
        textLink: "Cadastre-se",
        to: { name: 'Welcome', params: { mode: 'signup' } }
      })
    ]),
    (_unref(notification).type)
      ? (_openBlock(), _createBlock(_unref(AlertNotification), {
          key: 0,
          type: _unref(notification).type,
          message: _unref(notification).message
        }, null, 8, ["type", "message"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})